import axios, { AxiosInstance, AxiosRequestConfig } from "axios"
import { get } from "lodash-es"
import { Toast } from "vant"
import { getToken, setToken, setExpiresIn, setRefreshToken, getRefreshToken } from "@/utils/cookies"
import { showNotify, closeNotify, closeToast } from "vant"
import { useUserStoreHook } from "@/store/modules/user"
import { accountLogin } from "@/api/login"
import { getTokenIn } from "@/utils/cookies"
import router from "@/router"
import { useRoute } from "vue-router"
const route = useRoute()
// 刷新token
let isRefeshing = false
let requests: any = []

/** 创建请求实例 */
function createService() {
  // 创建一个 axios 实例
  const service = axios.create()
  // 请求拦截
  service.interceptors.request.use(
    (config: any) => {
      return config
    },
    // 发送失败
    (error: any) => Promise.reject(error)
  )
  // 响应拦截（可根据具体业务作出相应的调整）
  service.interceptors.response.use(
    (response: any) => {
      if (response.data.code != 200) {
        const text = response.data.message || response.data.msg || response.data
        console.log("登录错误提示语：")
        console.log(text)
        if (text == "重复请求，请稍后重试" || text.message === null) {
          console.log("")
        } else {
          if (text === "401") {
            localStorage.clear()
            router.push({ path: "/user", query: { from: "resource" } })
            const res2 = {
              ...response.data,
              message: "请重新登录"
            }
            return res2
          } else if (text == "认证失败，无法访问系统资源" && getTokenIn()) {
            setTimeout(() => {
              closeToast()
              showNotify({ type: "danger", message: "登录过期请重新登录" })
            }, 100)
          } else {
            setTimeout(() => {
              closeToast()
              showNotify({ type: "danger", message: text })
            }, 100)
          }
        }
      }
      // if (response.data.code === 500 && response.data.message === "401") {
      //   showNotify({ type: "warning", duration: 2500, message: "请重新登录" })
      //   localStorage.clear()
      //   router.push({ path: "/user", query: { from: "resource" } })
      //   return false
      // }
      const apiData = response.data
      return apiData
    },
    (error: any) => {
      // status 是 HTTP 状态码
      isRefeshing = true
      const status = get(error, "response.status")
      switch (status) {
        case 400:
          error.message = "请求错误"
          break
        case 401:
          if (isRefeshing) {
            const refreshToken: any = getRefreshToken()
            const submitForm = new FormData()
            submitForm.append("grant_type", "refresh_token")
            submitForm.append("refresh_token", refreshToken)
            submitForm.append("client_id", "backend-admin-app-client")
            submitForm.append("client_secret", "1q2w3e*")
            accountLogin(submitForm)
              .then((data: any) => {
                setToken(data.access_token)
                setExpiresIn(data.expires_in)
                setRefreshToken(data.refresh_token)

                isRefeshing = false
                return data.access_token
              })
              .then((accessToken: string) => {
                requests.forEach((config: any) => {
                  config.headers.Authorization = `Bearer ${accessToken}`
                  service(config)
                })
                requests = []
              })
              .catch(() => {
                isRefeshing = false
                useUserStoreHook().logout()
                location.reload()
              })

            return new Promise(() => {
              requests.push(error.config)
            })
          }
          error.message = "未授权，请登录"
          break
        case 403:
          // token 过期时，直接退出登录并强制刷新页面（会重定向到登录页）
          useUserStoreHook().logout()
          location.reload()
          break
        case 404:
          error.message = "请求地址出错"
          break
        case 408:
          error.message = "请求超时"
          break
        case 500:
          error.message = "服务器内部错误"
          break
        case 501:
          error.message = "服务未实现"
          break
        case 502:
          error.message = "网关错误"
          break
        case 503:
          error.message = "服务不可用"
          break
        case 504:
          error.message = "网关超时"
          break
        case 505:
          error.message = "HTTP版本不受支持"
          break
        case 598:
          error.message = "请求超时"
          break
        case 599:
          error.message = "请求超时"
          break
        default:
          error.message = "网络错误，请稍后重试"
          break
      }
      console.log("请求错误打印:")
      console.log(error)
      closeToast()
      showNotify({ type: "danger", message: error.message || "服务器错误" })
      // Toast.fail(error.message)
      return Promise.reject(error)
    }
  )
  return service
}

/** 创建请求方法 */
function createRequestFunction(service: AxiosInstance) {
  return function (config: AxiosRequestConfig) {
    const configDefault = {
      headers: {
        // 携带 token
        Authorization: "Bearer " + getToken(),
        "Content-Type": get(config, "headers.Content-Type", "application/json")
      },
      timeout: 300000,
      // baseURL: import.meta.env.VITE_BASE_API,
      // baseURL: "http://172.16.88.75:8201/",
      data: {}
    }
    return service(Object.assign(configDefault, config))
  }
}

/** 用于网络请求的实例 */
export const service = createService()
/** 用于网络请求的方法 */
export const request = createRequestFunction(service)

// export const serializeParams = (params: object) => {
//   return Object.entries(params)
//     .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
//     .join("&")
// }
function isEmpty(value: any) {
  if (value == "") return true
  if (Array.isArray(value) && value.length == 0) return true
  if (typeof value == "object" && value != null && Object.keys(value).length == 0) return true
  return false
}
export const serializeParams = (params: object) => {
  const newData = Object.fromEntries(
    Object.entries(params).filter(([key, value]) => {
      return value !== null && value !== undefined && value !== "" && !(Array.isArray(value) && value.length == 0)
    })
  )
  return (
    Object.entries(newData)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      // .map(([key, value]) => {
      //   // if (Array.isArray(value)) {
      //   //   const newDatas = JSON.stringify(value)
      //   //   return `${key}=${newDatas}`
      //   // } else {
      //   //   return `${key}=${value}`
      //   // }
      //   ;`${key}=${value}`
      // })
      .join("&")
  )
}
